import { render, staticRenderFns } from "./geoshapeGPS2.vue?vue&type=template&id=23df7622&scoped=true"
import script from "./geoshapeGPS2.vue?vue&type=script&lang=js"
export * from "./geoshapeGPS2.vue?vue&type=script&lang=js"
import style0 from "./geoshapeGPS2.vue?vue&type=style&index=0&id=23df7622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df7622",
  null
  
)

export default component.exports